import {
  AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery, useTheme, Chip,
} from "@mui/material";
import ManualAvatar from "../../Components/Avatar/Avatar";
import { ArrowDropDown, ArrowDropUp, Close, Menu, Notifications } from "@mui/icons-material";
import { useEffect, useState } from "react";
import ProfileMenu from "../../Components/ProfileDropDown";
import GetValidatedTokenData from "../../utils/helper";
import { Colors } from "../../Theme/Theme";
import FiLogo from "../../Components/FiLogo";

export default function Navbar({ handleDrawerToggle, mobileOpen }) {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [Data, setData] = useState({ name: "User", src: "", alt: "Profile" });

  useEffect(() => {
    const response = GetValidatedTokenData();
    setData({ name: response.userPayload?.name.toUpperCase(), src: "", alt: "Profile" });
  }, []);

  const handleMenuOpen = (event) => { setAnchorEl(event.currentTarget); setMenuOpen(!menuOpen); };
  const handleMenuClose = () => { setAnchorEl(null); setMenuOpen(false); };

  return (
    <AppBar
      position="relative" elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: Colors.white,
        borderBottom: `1px solid ${Colors.dividerColor}`,
        height: "64px",
      }}
    >
      <Toolbar sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", minHeight: "64px !important", px: { xs: 1.5, md: 2.5 }, overflow: "hidden" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0 }}>
          {isMediumScreen && (
            <IconButton onClick={handleDrawerToggle} sx={{ color: Colors.primaryTextColor }}>
              {mobileOpen ? <Close /> : <Menu />}
            </IconButton>
          )}
          <FiLogo size="lg" />
          <Chip
            label="Dashboard"
            size="small"
            sx={{
              height: 22, fontSize: "10px", fontWeight: 600,
              backgroundColor: Colors.blueSoft, color: Colors.primary,
              "& .MuiChip-label": { px: 1 },
              display: { xs: "none", sm: "flex" },
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
          <IconButton size="small" sx={{ color: Colors.secondaryColor, width: 36, height: 36, "&:hover": { backgroundColor: Colors.bgColor } }}>
            <Notifications sx={{ fontSize: 20 }} />
          </IconButton>

          <Box sx={{ width: "1px", height: 24, backgroundColor: Colors.dividerColor, mx: 0.5 }} />

          <Box
            onClick={handleMenuOpen}
            sx={{
              display: "flex", alignItems: "center", gap: 1, cursor: "pointer",
              px: 1, py: 0.5, borderRadius: "8px",
              "&:hover": { backgroundColor: Colors.bgColor },
            }}
          >
            <ManualAvatar
              src={Data.src} alt={Data.alt} name={Data?.name}
              width="30px" height="30px"
              sx={{ bgcolor: Colors.primary, color: Colors.white, fontSize: "12px", fontWeight: 700 }}
            />
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: Colors.primaryTextColor, display: { xs: "none", sm: "block" }, whiteSpace: "nowrap" }}>
              {Data?.name}
            </Typography>
            {menuOpen ? <ArrowDropUp sx={{ fontSize: 18, color: Colors.secondaryColor }} /> : <ArrowDropDown sx={{ fontSize: 18, color: Colors.secondaryColor }} />}
          </Box>
          {menuOpen && (
            <ProfileMenu anchorEl={anchorEl} open={menuOpen} handleMenuClose={handleMenuClose} Data={Data} />
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
